import * as React from 'react';

type ImgProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
};

export default function Image({
  src,
  alt,
  width,
  height,
  ...rest
}: ImgProps) {
  // next/image -> plain <img> (no optimization) for WordPress embed
  return <img src={src} alt={alt} width={width} height={height} {...rest} />;
}

